module.exports = __webpack_public_path__ + "img/card-review.ef37c13c.png";